import React from 'react'
import { BrowserRouter as Router} from 'react-router-dom';
import MainContent from './layout/MainContent'

//
// IMPORT ZONE
//

function App() {
  return (
   <>
     <Router>
       <MainContent />
     </Router>
   </>
  );
}

export default App;
